// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/waveService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  WaveDavDisponivel, WaveResumo, WaveDetalhe, WavePackItem, WavePedido,
  CriarWaveRequest, ConferirPedidoRequest,
} from '../types';
import type { PaginadoResponse } from '@/lib/consultas';
import { paramsConsulta, type FiltroConsultaOperacional } from '../consultas';

/** Filtros da consulta de waves: busca (nº/observação), dtInicio/dtFim (criação), status 0..4 ('todos' = sem filtro). */
export type FiltroWaves = Omit<FiltroConsultaOperacional, 'status'> & { status?: string };

const BASE = '/api/waves';

export const waveService = {
  async disponiveis(): Promise<WaveDavDisponivel[]> {
    const { data } = await apiClient.get<WaveDavDisponivel[]>(`${BASE}/disponiveis`);
    return data;
  },
  async getAll(pagina = 1, tamanhoPagina = 20, filtros?: FiltroWaves): Promise<PaginadoResponse<WaveResumo>> {
    const { data } = await apiClient.get<PaginadoResponse<WaveResumo>>(BASE, {
      params: { pagina, tamanhoPagina, ...paramsConsulta(filtros as FiltroConsultaOperacional) },
    });
    return data;
  },
  async getById(id: number): Promise<WaveDetalhe> {
    const { data } = await apiClient.get<WaveDetalhe>(`${BASE}/${id}`);
    return data;
  },
  async create(req: CriarWaveRequest): Promise<WaveDetalhe> {
    const { data } = await apiClient.post<WaveDetalhe>(BASE, req);
    return data;
  },
  async iniciarSeparacao(id: number): Promise<WaveDetalhe> {
    const { data } = await apiClient.put<WaveDetalhe>(`${BASE}/${id}/iniciar-separacao`, {});
    return data;
  },
  async concluirSeparacao(id: number): Promise<WaveDetalhe> {
    const { data } = await apiClient.put<WaveDetalhe>(`${BASE}/${id}/concluir-separacao`, {});
    return data;
  },
  async distribuir(id: number): Promise<WaveDetalhe> {
    const { data } = await apiClient.put<WaveDetalhe>(`${BASE}/${id}/distribuir`, {});
    return data;
  },
  async cancelar(id: number): Promise<WaveDetalhe> {
    const { data } = await apiClient.put<WaveDetalhe>(`${BASE}/${id}/cancelar`, {});
    return data;
  },
  async itensPedido(waveId: number, pedidoId: number): Promise<WavePackItem[]> {
    const { data } = await apiClient.get<WavePackItem[]>(`${BASE}/${waveId}/pedidos/${pedidoId}/itens`);
    return data;
  },
  async conferir(waveId: number, pedidoId: number, req: ConferirPedidoRequest): Promise<WavePedido> {
    const { data } = await apiClient.post<WavePedido>(`${BASE}/${waveId}/pedidos/${pedidoId}/conferir`, req);
    return data;
  },
};
